import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-cream px-4 py-14" data-id="element-94" data-mp="1cl62xaqxlmhl">
      <div className="mx-auto w-full max-w-3xl" data-id="element-95" data-mp="1clzdynwxay5j">
        <p className="flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-gold-dark" data-id="element-96" data-mp="18jkqtrm81c8g">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-97" data-mp="25a3llez21lav" />
          Exclusive Bonuses
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-98" data-mp="20aihyr8xwort">
          Included <span className="italic text-gold-dark" data-id="element-99" data-mp="1w7lxsw3r4klr">FREE</span> Today
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] leading-relaxed text-ink-soft" data-id="element-100" data-mp="1r90xyxsew2xu">
          Designed to make everything faster, easier, and safer for you.
        </p>

        <div className="mt-8 space-y-4" data-id="element-101" data-mp="funmytirbhz8">
          {bonuses.map(bonus => <article key={bonus.title} className="overflow-hidden rounded-3xl border border-gold/20 bg-white p-4 sm:p-5" data-id="element-102" data-mp="1etwsn7cu6agv">
              <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-start" data-id="element-103" data-mp="1jryj4dcldc2d">
                <img src={bonus.image} alt={`${bonus.title} cover`} className="w-40 shrink-0 sm:w-44" loading="lazy" data-id="element-104" data-mp="15sp61mjomy2m" />
                <div className="min-w-0 flex-1 text-center sm:text-left" data-id="element-105" data-mp="w12m91ta3qo9">
                  <h3 className="font-display text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-106" data-mp="10unmz1m9ayr5">
                    {bonus.title}
                  </h3>
                  <p className="mt-1.5 text-[14px] leading-relaxed text-ink-soft" data-id="element-107" data-mp="r3syrrpg9p32">
                    {bonus.description}
                  </p>
                  <p className="mt-1.5 text-[13px] font-semibold text-gold-dark" data-id="element-108" data-mp="d4tboohl5i90">
                    → {bonus.highlight}
                  </p>
                  <p className="mt-3 inline-flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1 text-[12px] font-bold text-emerald-700" data-id="element-109" data-mp="2jsjxcmpgppki">
                    <span className="line-through opacity-60" data-id="element-110" data-mp="2f11v7vbpdixy">Value {bonus.value}</span>
                    <span data-id="element-111" data-mp="2b1b9w74y3v0t">FREE</span>
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCTA headline="Get all 5 bonuses without paying a dollar extra." data-id="element-112" data-mp="25z2fr7gc6mx4" />
      </div>
    </section>;
}